/**
 * @description 考试查看图表组建
 * @author lhu
 * @date 20200422
 */
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'dva'
import { modelUtils } from '../../../../../utils'
import ResultPercent  from './resultPercent'
import { component_tool, framework_tool, utils_tool } from '@/tool'
let {
  WizCard,
  WizBizcharts
} = component_tool;
let { WizContainer } = framework_tool;

class ExamResultCharts extends WizContainer {

    componentName = 'ExamResultCharts';

    constructor(props){
        super(props);
      }

    _componentDidMount() {
       // this._getData()
    }

    _getData(other = {}) {
        this.doAction({
            path: `classStudentExam/queryClassExamInfo`,
            payload: {
              key: `classStudentExam@queryClassExamInfo`,
              apiParams: {classInfoId:this.props.classInfoId,examId:this.props.examId} 
            }
        });
      };

    state = {
    };

    propsAndStateOnChange = {
      classStudentExamInfo: this._getClassStudentExamInfoOver.bind(this)
      }

      _getClassStudentExamInfoOver(nextProps, nextState) {
        let data = [];
        if (nextProps.classStudentExamInfo.code === 1) {
          data = nextProps.classStudentExamInfo.data;
          this.chartsData = data;
          return data;
        } else {
          wizNotice.error('图表数据获取失败！！');
          return false;
        }
      }

    _render() {
      let titles = ['考试名称','考试时间'];
      let values = this.chartsData ?[
            this.chartsData.examName,
            this.chartsData.startDate+' ～ '+this.chartsData.endDate]
            :['',''];
      let resultPrecent = this.chartsData ? <ResultPercent key={new Date().getTime()+'_classResultPercent'}
      headerProps={{ title: titles, value: values}}
      percentProps={{
        data: [
          {
            item: "通过人数",
            count: this.chartsData.passCount <0 ?0:this.chartsData.passCount ,
          },
          {
            item: "未通过人数",
            count: this.chartsData.noPassCount < 0?0:this.chartsData.noPassCount,
          },
          {
            item: "未参加人数",
            count: this.chartsData.noPartInCount <0?0:this.chartsData.noPartInCount,
          }
        ],
        dataFormat: {
          type: "percent",
          field: "count",
          dimension: "item",
          as: "percent"
        },
        count: this.chartsData.totalCount && this.chartsData.totalCount,
        centerText: '考试人数'
      }}
      // itemProps={[
      //   { img: constants.files.sys_exam_precent_max, title: '最高分', value: this.chartsData.maxScore + '分' },
      //   { img: constants.files.sys_exam_precent_avg, title: '平均分', value: this.chartsData.avgScore + '分' },
      //   { img: constants.files.sys_exam_precent_min, title: '最低分', value: this.chartsData.minScore + '分' }
      // ]}
    /> : null;

        return [
            <WizCard title={'环节概况'} key={new Date().getTime()} bodyStyle={{paddingLeft:20,paddingBottom:0,paddingTop:15}}>
                {resultPrecent}
            </WizCard>
        ]
    }
}

const mapStateToProps = (state, ownProps) => {
    const { classStudentExam } = state;
    const classStudentExamInfo = modelUtils.getModelEntity(classStudentExam, "classStudentExam@queryClassExamInfo");
    return {
      classStudentExamInfo:classStudentExamInfo,
    };
};

export default connect(mapStateToProps)(ExamResultCharts);
